import React from "react";
import { Email, Phone, LocationOn } from "@mui/icons-material";
import FacebookIcon from "@mui/icons-material/Facebook";
import TelegramIcon from "@mui/icons-material/Telegram";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import RssFeedIcon from "@mui/icons-material/RssFeed";

import payme from "../../assets/footer/payme.svg";
import visa from "../../assets/footer/visa.svg";
import mastercard from "../../assets/footer/mastercard.svg";
import humo from "../../assets/footer/humo.svg";
import uzcard from "../../assets/footer/uzcard.svg";


function Footer() {
  return (
    <div className="w-screen py-1 rounded-xl mt-20 bg-white h-auto flex flex-col justify-center items-center">
      <div className="h-full py-3 rounded-xl bg-white w-11/12 mx-auto flex flex-col justify-center">
        <div className="grid pb-6 border-b-2 grid-cols-2 md:grid-cols-3 gap-4 mb-10">
          <div className="flex flex-col justify-evenly">
            <div className="font-bold mb-2">Ma'lumotlar</div>
            <a href="#" className="text-gray-500 hover:text-blue-500">
              Ko'p so'raladigan savollar
            </a>
            <a href="#" className="text-gray-500 hover:text-blue-500">
              Olib ketish punktlari
            </a>
            <a href="#" className="text-gray-500 hover:text-blue-500">
              Blog
            </a>
            <a href="#" className="text-gray-500 hover:text-blue-500">
              Bizning brendlarimiz
            </a>
            <a
              href="#"
              className="text-gray-500 hover:text-blue-500"
            >
              Ommaviy oferta (Foydalanuvchi bitimi)
            </a>
            <a href="#" className="text-gray-500 hover:text-blue-500">
              Muddatli to'lov asosida sotib olishning umumiy qoidalari
            </a>
            <a href="#" className="text-gray-500 hover:text-blue-500">
              Biz haqimizda
            </a>
          </div>

          <div className="flex flex-col justify-evenly">
            <div className="font-bold mb-2">Biz bilan aloqa</div>
            <a href="#" className="text-gray-500 hover:text-blue-500">
              <Phone />
              +998 71 200 01 05
            </a>
            <a href="#" className="text-gray-500 hover:text-blue-500">
              <Email />
              info@asaxiy.uz
            </a>
            <a href="#" className="text-gray-500 hover:text-blue-500">
              <LocationOn />
              Islom Karimov, 49, Toshkent
            </a>
          </div>

          <div className="flex flex-col justify-evenly">
            <div className="font-bold mb-2">Kitob do'konlarimiz</div>
            <a href="#" className="text-gray-500 hover:text-blue-500">
              <LocationOn />
              Asaxiy Novza
            </a>
            <a href="#" className="text-gray-500 hover:text-blue-500">
              <LocationOn />
              Asaxiy Farhod bozori
            </a>
            <a href="#" className="text-gray-500 hover:text-blue-500">
              <LocationOn />
              Asaxiy Panoraman, Kitob olami
            </a>
          </div>

          <div className="flex flex-col justify-evenly">
            <div className="font-bold mb-2">Erishgan yutuqlarimiz</div>
            <a href="#" className="text-gray-500 hover:text-blue-500">
              "Tahsin" mukofoti
            </a>
            <a href="#" className="text-gray-500 hover:text-blue-500">
              "Shuhrat" medali
            </a>
            <a href="#" className="text-gray-500 hover:text-blue-500">
              "Kelajak bunyodkori" medali
            </a>
          </div>

          <div>
            <div className="font-bold mb-2">Biz ijtimoiy tarmoqlarda</div>
            <div className="flex space-x-2">
              <FacebookIcon className="text-gray-500 hover:text-blue-500" />
              <TelegramIcon className="text-gray-500 hover:text-blue-500" />
              <InstagramIcon className="text-gray-500 hover:text-blue-500" />
              <YouTubeIcon className="text-gray-500 hover:text-blue-500" />
              <RssFeedIcon className="text-gray-500 hover:text-blue-500" />
            </div>
          </div>

          <div>
            <div className="font-bold mb-2">To'lov turlari</div>
            <div className="grid grid-cols-3 gap-4">
              <div className="p-4 bg-bgColor">
                <img src={payme} alt="payme" />
              </div>
              <div className="p-4 bg-bgColor">
                <img src={visa} alt="payme" />
              </div>
              <div className="p-4 bg-bgColor">
                <img src={mastercard} alt="payme" />
              </div>
              <div className="p-4 bg-bgColor">
                <img src={humo} alt="payme" />
              </div>
              <div className="p-4 bg-bgColor">
                <img src={uzcard} alt="payme" />
              </div>
            </div>
          </div>
        </div>

        <div className="text-xl text-gray-500 flex justify-center">
          2015-2023 Internet-do'kon asaxiy.uz: Maishiy texnikalar va boshqalr.
          Mahsulotni yetkazib berish barcha viloyatlarda amalga oshiriladi.
          Barcha huquqlar himoyalangan
        </div>
      </div>
    </div>
  );
}

export default Footer;
